import { LogoMark } from "./Logo";
import { scrollToSection } from "./Navbar";

export const Footer = () => (
  <footer className="relative bg-[#121512] border-t border-[#FBF9F4]/10 py-16 sm:py-20" data-testid="site-footer">
    <div className="max-w-[1440px] mx-auto px-6 sm:px-10">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12">
        <div>
          <LogoMark showEst className="text-[#FBF9F4]" />
          <p className="font-mono-brand text-[10px] uppercase tracking-[0.28em] text-[#A3B899] mt-4">
            Kaupapa Māori Medicinal Cannabis Cultivation &amp; Research
          </p>
        </div>
        <div className="flex flex-wrap gap-x-10 gap-y-4">
          {[
            { label: "Kaupapa", href: "#kaupapa", testid: "footer-link-kaupapa" },
            { label: "What We Do", href: "#what-we-do", testid: "footer-link-what-we-do" },
            { label: "The Plan", href: "#roadmap", testid: "footer-link-roadmap" },
            { label: "Contact", href: "#contact", testid: "footer-link-contact" },
          ].map((l) => (
            <button
              key={l.href}
              onClick={() => scrollToSection(l.href)}
              data-testid={l.testid}
              className="font-mono-brand text-[11px] uppercase tracking-[0.22em] text-[#D1D8D2]/70 transition-colors duration-300 hover:text-[#D4A359]"
            >
              {l.label}
            </button>
          ))}
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-[#FBF9F4]/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <p className="text-xs text-[#D1D8D2]/50">Aotea Biotech Limited · NZBN 9429054029262 · Auckland, New Zealand</p>
        <p className="text-xs text-[#D1D8D2]/50">© 2026 Aotea Biotech Ltd. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
